import { render, staticRenderFns } from "./WhyChooseScad.vue?vue&type=template&id=4e2c9e9c&scoped=true&"
import script from "./WhyChooseScad.vue?vue&type=script&lang=js&"
export * from "./WhyChooseScad.vue?vue&type=script&lang=js&"
import style0 from "./WhyChooseScad.vue?vue&type=style&index=0&id=4e2c9e9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2c9e9c",
  null
  
)

export default component.exports